import { createI18n } from "vue-i18n";
import zhCN from "./zh-CN";
import en from "./en";

// IP检测工具（判断国内/海外IP）
export const checkIsChinaIp = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/", { timeout: 5000 });
    const data = await res.json();
    return data.country_code === "CN";
  } catch (error) {
    console.error("IP检测失败，默认使用中文", error);
    return true;
  }
};

const messages = {
  "zh-CN": zhCN,
  en: en
};

const i18n = createI18n({
  legacy: false, // 适配Vue 3组合式API
  locale: "zh-CN", // 默认语言
  fallbackLocale: "zh-CN", // 兜底语言
  messages,
  globalInjection: true // 全局注入$t方法
});

export default i18n;